/* ==========================================================================
   CP-SIZE-FINDER: behaviour for sections/cp-home-size-finder.liquid.
   Everything is rendered on the server; this only
     - switches the use tabs (click, arrow keys, theme-editor block select),
     - drives each gallery (swipe via scroll-snap, arrows, thumbnails, counter),
     - keeps the "Add N to cart — $X" button in step with the chosen pack,
     - adds to cart through the cart drawer (window.cpAddToCart) when present.
   ========================================================================== */
(function () {
  "use strict";
  if (window.__cpSfLoaded) return;
  window.__cpSfLoaded = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return (n < 10 ? "0" : "") + n; }

  /* ------------------------------------------------------------ gallery */
  function initGallery(panel) {
    var track = qs("[data-sf-track]", panel);
    if (!track || track.__sf) return;
    track.__sf = true;
    var slides = qsa("[data-sf-slide]", track);
    var thumbs = qsa("[data-sf-thumb]", panel);
    var prev = qs("[data-sf-prev]", panel), next = qs("[data-sf-next]", panel);
    var count = qs("[data-sf-count]", panel);
    var idx = 0, raf = 0, lock = null, lockT = 0;

    function set(i) {
      idx = i;
      thumbs.forEach(function (t, k) { t.setAttribute("aria-current", k === i ? "true" : "false"); });
      if (count) count.textContent = pad(i + 1);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      var t = thumbs[i], rail = t && t.parentElement;
      if (rail && rail.scrollHeight > rail.clientHeight + 2) {
        var top = t.offsetTop - rail.offsetTop;
        if (top < rail.scrollTop || top + t.offsetHeight > rail.scrollTop + rail.clientHeight) rail.scrollTo({ top: top - 8, behavior: reduce ? "auto" : "smooth" });
      } else if (rail && rail.scrollWidth > rail.clientWidth + 2) {
        var left = t.offsetLeft - rail.offsetLeft;
        if (left < rail.scrollLeft || left + t.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: left - 8, behavior: reduce ? "auto" : "smooth" });
      }
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      /* ignore the scroll events of our own animation, so the thumbs don't flicker through */
      lock = i;
      clearTimeout(lockT);
      lockT = setTimeout(function () { lock = null; }, 900);
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? "auto" : "smooth" });
      set(i);
    }
    track.addEventListener("scroll", function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (lock !== null) {
          if (Math.abs(track.scrollLeft - lock * track.clientWidth) < 2) { lock = null; clearTimeout(lockT); }
          return;
        }
        if (i !== idx) set(i);
      });
    }, { passive: true });
    track.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") { e.preventDefault(); go(idx + 1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); go(idx - 1); }
    });
    if (prev) prev.addEventListener("click", function () { go(idx - 1); });
    if (next) next.addEventListener("click", function () { go(idx + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { go(parseInt(t.getAttribute("data-sf-thumb"), 10) || 0); });
    });
    /* the panel was hidden while the page laid out: snap back to the current slide once shown */
    panel.__sfSync = function () { lock = idx; track.scrollLeft = idx * track.clientWidth; };
    window.addEventListener("resize", function () { if (!panel.hidden) panel.__sfSync(); }, { passive: true });
    set(0);
  }

  /* --------------------------------------------------- packs and buttons */
  function initBuy(panel) {
    var form = qs("[data-sf-form][data-live]", panel);
    if (!form || form.__sf) return;
    form.__sf = true;
    var add = qs("[data-sf-add]", form), addLabel = qs("[data-sf-add-label]", form), addPrice = qs("[data-sf-add-price]", form);
    var tryBtn = qs("[data-sf-try]", form), msg = qs("[data-sf-msg]", form);
    var busy = false;

    function chosen() { return qs("[data-sf-pack]:checked", form); }
    function paint() {
      var c = chosen();
      if (!add) return;
      if (!c) { add.disabled = true; if (addLabel) addLabel.textContent = "Sold out"; if (addPrice) addPrice.textContent = ""; return; }
      add.disabled = busy;
      if (addLabel) addLabel.textContent = c.getAttribute("data-cta");
      if (addPrice) addPrice.textContent = c.getAttribute("data-price");
    }
    function say(t) { if (!msg) return; msg.textContent = t || ""; msg.hidden = !t; }

    function send(id, btn, labelEl) {
      if (busy || !id) return;
      busy = true; say("");
      var before = labelEl ? labelEl.textContent : "";
      btn.setAttribute("aria-busy", "true");
      if (btn === add) add.disabled = true;
      if (labelEl) labelEl.textContent = "Adding…";
      var body = { items: [{ id: +id, quantity: 1 }] };
      var req = window.cpAddToCart
        ? window.cpAddToCart(body)
        : fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
            .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || "We could not add that to your cart."); location.href = "/cart"; return d; }); });
      req.then(function () {
        busy = false;
        btn.removeAttribute("aria-busy");
        if (labelEl) labelEl.textContent = "Added ✓";
        setTimeout(function () { if (labelEl) labelEl.textContent = before; paint(); }, 1600);
      }).catch(function (err) {
        busy = false;
        btn.removeAttribute("aria-busy");
        if (labelEl) labelEl.textContent = before;
        paint();
        say(err && err.message ? err.message : "Something went wrong. Please try again.");
      });
    }

    form.addEventListener("change", function (e) { if (e.target.matches("[data-sf-pack]")) { say(""); paint(); } });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var c = chosen();
      if (c) send(c.value, add, addLabel);
    });
    if (tryBtn) tryBtn.addEventListener("click", function () { send(tryBtn.getAttribute("data-sf-try"), tryBtn, qs("[data-sf-try-label]", tryBtn)); });
    paint();
  }

  /* ---------------------------------------------------------------- tabs */
  function init(root) {
    if (root.__sf) return;
    root.__sf = true;
    var tabs = qsa("[data-sf-tab]", root);
    var panels = qsa("[data-sf-panel]", root);

    function select(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute("data-sf-tab") === key;
        t.setAttribute("aria-selected", on ? "true" : "false");
        t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) {
        var on = p.getAttribute("data-sf-panel") === key;
        if (on && p.hidden) {
          p.hidden = false;
          p.classList.remove("is-in");
          void p.offsetWidth;
          p.classList.add("is-in");
          if (p.__sfSync) p.__sfSync();
        } else if (!on) {
          p.hidden = true;
        }
      });
    }
    root.__sfSelect = select;

    tabs.forEach(function (t, i) {
      t.addEventListener("click", function () { select(t.getAttribute("data-sf-tab")); });
      t.addEventListener("keydown", function (e) {
        var j = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") j = (i + 1) % tabs.length;
        else if (e.key === "ArrowLeft" || e.key === "ArrowUp") j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === "Home") j = 0;
        else if (e.key === "End") j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j].getAttribute("data-sf-tab"), true);
      });
    });
    panels.forEach(function (p) { initGallery(p); initBuy(p); });
  }

  function boot() { qsa("[data-cp-sf]").forEach(init); }

  /* theme editor */
  document.addEventListener("shopify:section:load", function (e) { qsa("[data-cp-sf]", e.target).forEach(init); });
  document.addEventListener("shopify:block:select", function (e) {
    var root = e.target.closest && e.target.closest("[data-cp-sf]");
    var key = e.target.getAttribute && e.target.getAttribute("data-sf-tab");
    if (root && key && root.__sfSelect) root.__sfSelect(key);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
